import { useEffect } from 'react';
import { PrinterSettings, PrinterType } from '~/types/printer';
import message from '~/utils/message';
import { api } from '@restaurant/api';

export const useInitWifiPrinter = ({
  settings,
  saveSettings,
}: {
  settings: PrinterSettings;
  saveSettings: (value: PrinterSettings) => void;
}) => {
  useEffect(() => {
    if (settings.type !== PrinterType.Wifi) {
      return;
    }

    if (!settings.printerId) {
      message.warning('Printer Wi-Fi belum tersetup, harap segera setup');
      return;
    }

    let current = true;

    (async () => {
      try {
        const { printers } = await api.fetchPrinters();
        if (!current) return false;
        const usedPrinter = printers?.find(
          ({ printerId, isActive }) =>
            printerId === settings.printerId && isActive
        );
        if (usedPrinter) {
          message.success(
            `Berhasil setup Printer Wi-Fi, kasir menggunakan printer: ${usedPrinter.name}`
          );
          return;
        }
        message.warning('Printer Wi-Fi belum tersetup, harap segera setup');
      } catch (e: any) {
        message.error(
          `Gagal setup printer Wi-Fi, harap setup ulang. Error ${e.message}`
        );
      }
      saveSettings({ ...settings, printerId: undefined });
    })();

    return () => {
      current = false;
    };
  }, []);
};
